export default [
    {
        areaId: '110000',
        areaName: '北京市',
        disabled: false,
        child: [
            { areaId: '110101', areaName: '东城区' },
            { areaId: '110102', areaName: '西城区' },
            { areaId: '110105', areaName: '朝阳区' },
            { areaId: '110106', areaName: '丰台区' },
            { areaId: '110107', areaName: '石景山区' },
            { areaId: '110108', areaName: '海淀区' },
            { areaId: '110109', areaName: '门头沟区' },
            { areaId: '110111', areaName: '房山区' },
            { areaId: '110112', areaName: '通州区' },
            { areaId: '110113', areaName: '顺义区' },
            { areaId: '110114', areaName: '昌平区' },
            { areaId: '110115', areaName: '大兴区' },
            { areaId: '110116', areaName: '怀柔区' },
            { areaId: '110117', areaName: '平谷区' },
            { areaId: '110118', areaName: '密云区' },
            { areaId: '110119', areaName: '延庆区' }
        ]
    },
    {
        areaId: '120000',
        areaName: '天津市',
        disabled: false,
        child: [
            { areaId: '120101', areaName: '和平区' },
            { areaId: '120102', areaName: '河东区' },
            { areaId: '120103', areaName: '河西区' },
            { areaId: '120104', areaName: '南开区' },
            { areaId: '120105', areaName: '河北区' },
            { areaId: '120106', areaName: '红桥区' },
            { areaId: '120110', areaName: '东丽区' },
            { areaId: '120111', areaName: '西青区' },
            { areaId: '120112', areaName: '津南区' },
            { areaId: '120113', areaName: '北辰区' },
            { areaId: '120114', areaName: '武清区' },
            { areaId: '120115', areaName: '宝坻区' },
            { areaId: '120116', areaName: '滨海新区' },
            { areaId: '120117', areaName: '宁河区' },
            { areaId: '120118', areaName: '静海区' },
            { areaId: '120119', areaName: '蓟州区' }
        ]
    },
    {
        areaId: '130000',
        areaName: '河北省',
        disabled: false,
        child: [
            { areaId: '130100', areaName: '石家庄市' },
            { areaId: '130200', areaName: '唐山市' },
            { areaId: '130300', areaName: '秦皇岛市' },
            { areaId: '130400', areaName: '邯郸市' },
            { areaId: '130500', areaName: '邢台市' },
            { areaId: '130600', areaName: '保定市' },
            { areaId: '130700', areaName: '张家口市' },
            { areaId: '130800', areaName: '承德市' },
            { areaId: '130900', areaName: '沧州市' },
            { areaId: '131000', areaName: '廊坊市' },
            { areaId: '131100', areaName: '衡水市' }
        ]
    },
    {
        areaId: '140000',
        areaName: '山西省',
        disabled: false,
        child: [
            { areaId: '140100', areaName: '太原市' },
            { areaId: '140200', areaName: '大同市' },
            { areaId: '140300', areaName: '阳泉市' },
            { areaId: '140400', areaName: '长治市' },
            { areaId: '140500', areaName: '晋城市' },
            { areaId: '140600', areaName: '朔州市' },
            { areaId: '140700', areaName: '晋中市' },
            { areaId: '140800', areaName: '运城市' },
            { areaId: '140900', areaName: '忻州市' },
            { areaId: '141000', areaName: '临汾市' },
            { areaId: '141100', areaName: '吕梁市' }
        ]
    },
    {
        areaId: '150000',
        areaName: '内蒙古自治区',
        disabled: false,
        child: [
            { areaId: '150100', areaName: '呼和浩特市' },
            { areaId: '150200', areaName: '包头市' },
            { areaId: '150300', areaName: '乌海市' },
            { areaId: '150400', areaName: '赤峰市' },
            { areaId: '150500', areaName: '通辽市' },
            { areaId: '150600', areaName: '鄂尔多斯市' },
            { areaId: '150700', areaName: '呼伦贝尔市' },
            { areaId: '150800', areaName: '巴彦淖尔市' },
            { areaId: '150900', areaName: '乌兰察布市' },
            { areaId: '152200', areaName: '兴安盟' },
            { areaId: '152500', areaName: '锡林郭勒盟' },
            { areaId: '152900', areaName: '阿拉善盟' }
        ]
    },
    {
        areaId: '210000',
        areaName: '辽宁省',
        disabled: false,
        child: [
            { areaId: '210100', areaName: '沈阳市' },
            { areaId: '210200', areaName: '大连市' },
            { areaId: '210300', areaName: '鞍山市' },
            { areaId: '210400', areaName: '抚顺市' },
            { areaId: '210500', areaName: '本溪市' },
            { areaId: '210600', areaName: '丹东市' },
            { areaId: '210700', areaName: '锦州市' },
            { areaId: '210800', areaName: '营口市' },
            { areaId: '210900', areaName: '阜新市' },
            { areaId: '211000', areaName: '辽阳市' },
            { areaId: '211100', areaName: '盘锦市' },
            { areaId: '211200', areaName: '铁岭市' },
            { areaId: '211300', areaName: '朝阳市' },
            { areaId: '211400', areaName: '葫芦岛市' }
        ]
    },
    {
        areaId: '220000',
        areaName: '吉林省',
        disabled: false,
        child: [
            { areaId: '220100', areaName: '长春市' },
            { areaId: '220200', areaName: '吉林市' },
            { areaId: '220300', areaName: '四平市' },
            { areaId: '220400', areaName: '辽源市' },
            { areaId: '220500', areaName: '通化市' },
            { areaId: '220600', areaName: '白山市' },
            { areaId: '220700', areaName: '松原市' },
            { areaId: '220800', areaName: '白城市' },
            { areaId: '222400', areaName: '延边朝鲜族自治州' }
        ]
    },
    {
        areaId: '230000',
        areaName: '黑龙江省',
        disabled: false,
        child: [
            { areaId: '230100', areaName: '哈尔滨市' },
            { areaId: '230200', areaName: '齐齐哈尔市' },
            { areaId: '230300', areaName: '鸡西市' },
            { areaId: '230400', areaName: '鹤岗市' },
            { areaId: '230500', areaName: '双鸭山市' },
            { areaId: '230600', areaName: '大庆市' },
            { areaId: '230700', areaName: '伊春市' },
            { areaId: '230800', areaName: '佳木斯市' },
            { areaId: '230900', areaName: '七台河市' },
            { areaId: '231000', areaName: '牡丹江市' },
            { areaId: '231100', areaName: '黑河市' },
            { areaId: '231200', areaName: '绥化市' },
            { areaId: '232700', areaName: '大兴安岭地区' }
        ]
    },
    {
        areaId: '310000',
        areaName: '上海市',
        disabled: false,
        child: [{ areaId: '310101', areaName: '黄浦区' },
            { areaId: '310104', areaName: '徐汇区' },
            { areaId: '310105', areaName: '长宁区' },
            { areaId: '310106', areaName: '静安区' },
            { areaId: '310107', areaName: '普陀区' },
            { areaId: '310109', areaName: '虹口区' },
            { areaId: '310110', areaName: '杨浦区' },
            { areaId: '310112', areaName: '闵行区' },
            { areaId: '310113', areaName: '宝山区' },
            { areaId: '310114', areaName: '嘉定区' },
            { areaId: '310115', areaName: '浦东新区' },
            { areaId: '310116', areaName: '金山区' },
            { areaId: '310117', areaName: '松江区' },
            { areaId: '310118', areaName: '青浦区' },
            { areaId: '310120', areaName: '奉贤区' },
            { areaId: '310151', areaName: '崇明区' }
        ]
    },
    {
        areaId: '320000',
        areaName: '江苏省',
        disabled: false,
        child: [
            { areaId: '320100', areaName: '南京市' },
            { areaId: '320200', areaName: '无锡市' },
            { areaId: '320300', areaName: '徐州市' },
            { areaId: '320400', areaName: '常州市' },
            { areaId: '320500', areaName: '苏州市' },
            { areaId: '320600', areaName: '南通市' },
            { areaId: '320700', areaName: '连云港市' },
            { areaId: '320800', areaName: '淮安市' },
            { areaId: '320900', areaName: '盐城市' },
            { areaId: '321000', areaName: '扬州市' },
            { areaId: '321100', areaName: '镇江市' },
            { areaId: '321200', areaName: '泰州市' },
            { areaId: '321300', areaName: '宿迁市' }
        ]
    },
    {
        areaId: '330000',
        areaName: '浙江省',
        disabled: false,
        child: [
            { areaId: '330100', areaName: '杭州市' },
            { areaId: '330200', areaName: '宁波市' },
            { areaId: '330300', areaName: '温州市' },
            { areaId: '330400', areaName: '嘉兴市' },
            { areaId: '330500', areaName: '湖州市' },
            { areaId: '330600', areaName: '绍兴市' },
            { areaId: '330700', areaName: '金华市' },
            { areaId: '330800', areaName: '衢州市' },
            { areaId: '330900', areaName: '舟山市' },
            { areaId: '331000', areaName: '台州市' },
            { areaId: '331100', areaName: '丽水市' }
        ]
    },
    {
        areaId: '340000',
        areaName: '安徽省',
        disabled: false,
        child: [
            { areaId: '340100', areaName: '合肥市' },
            { areaId: '340200', areaName: '芜湖市' },
            { areaId: '340300', areaName: '蚌埠市' },
            { areaId: '340400', areaName: '淮南市' },
            { areaId: '340500', areaName: '马鞍山市' },
            { areaId: '340600', areaName: '淮北市' },
            { areaId: '340700', areaName: '铜陵市' },
            { areaId: '340800', areaName: '安庆市' },
            { areaId: '341000', areaName: '黄山市' },
            { areaId: '341100', areaName: '滁州市' },
            { areaId: '341200', areaName: '阜阳市' },
            { areaId: '341300', areaName: '宿州市' },
            { areaId: '341400', areaName: '巢湖市' },
            { areaId: '341500', areaName: '六安市' },
            { areaId: '341600', areaName: '亳州市' },
            { areaId: '341700', areaName: '池州市' },
            { areaId: '341800', areaName: '宣城市' }
        ]
    },
    {
        areaId: '350000',
        areaName: '福建省',
        disabled: false,
        child: [
            { areaId: '350100', areaName: '福州市' },
            { areaId: '350200', areaName: '厦门市' },
            { areaId: '350300', areaName: '莆田市' },
            { areaId: '350400', areaName: '三明市' },
            { areaId: '350500', areaName: '泉州市' },
            { areaId: '350600', areaName: '漳州市' },
            { areaId: '350700', areaName: '南平市' },
            { areaId: '350800', areaName: '龙岩市' },
            { areaId: '350900', areaName: '宁德市' }
        ]
    },
    {
        areaId: '360000',
        areaName: '江西省',
        disabled: false,
        child: [
            { areaId: '360100', areaName: '南昌市' },
            { areaId: '360200', areaName: '景德镇市' },
            { areaId: '360300', areaName: '萍乡市' },
            { areaId: '360400', areaName: '九江市' },
            { areaId: '360500', areaName: '新余市' },
            { areaId: '360600', areaName: '鹰潭市' },
            { areaId: '360700', areaName: '赣州市' },
            { areaId: '360800', areaName: '吉安市' },
            { areaId: '360900', areaName: '宜春市' },
            { areaId: '361000', areaName: '抚州市' },
            { areaId: '361100', areaName: '上饶市' }
        ]
    },
    {
        areaId: '370000',
        areaName: '山东省',
        disabled: false,
        child: [
            { areaId: '370100', areaName: '济南市' },
            { areaId: '370200', areaName: '青岛市' },
            { areaId: '370300', areaName: '淄博市' },
            { areaId: '370400', areaName: '枣庄市' },
            { areaId: '370500', areaName: '东营市' },
            { areaId: '370600', areaName: '烟台市' },
            { areaId: '370700', areaName: '潍坊市' },
            { areaId: '370800', areaName: '济宁市' },
            { areaId: '370900', areaName: '泰安市' },
            { areaId: '371000', areaName: '威海市' },
            { areaId: '371100', areaName: '日照市' },
            { areaId: '371200', areaName: '莱芜市' },
            { areaId: '371300', areaName: '临沂市' },
            { areaId: '371400', areaName: '德州市' },
            { areaId: '371500', areaName: '聊城市' },
            { areaId: '371600', areaName: '滨州市' },
            { areaId: '371700', areaName: '菏泽市' }
        ]
    },
    {
        areaId: '410000',
        areaName: '河南省',
        disabled: false,
        child: [
            { areaId: '410100', areaName: '郑州市' },
            { areaId: '410200', areaName: '开封市' },
            { areaId: '410300', areaName: '洛阳市' },
            { areaId: '410400', areaName: '平顶山市' },
            { areaId: '410500', areaName: '安阳市' },
            { areaId: '410600', areaName: '鹤壁市' },
            { areaId: '410700', areaName: '新乡市' },
            { areaId: '410800', areaName: '焦作市' },
            { areaId: '410900', areaName: '濮阳市' },
            { areaId: '411000', areaName: '许昌市' },
            { areaId: '411100', areaName: '漯河市' },
            { areaId: '411200', areaName: '三门峡市' },
            { areaId: '411300', areaName: '南阳市' },
            { areaId: '411400', areaName: '商丘市' },
            { areaId: '411500', areaName: '信阳市' },
            { areaId: '411600', areaName: '周口市' },
            { areaId: '411700', areaName: '驻马店市' }
        ]
    },
    {
        areaId: '420000',
        areaName: '湖北省',
        disabled: false,
        child: [
            { areaId: '420100', areaName: '武汉市' },
            { areaId: '420200', areaName: '黄石市' },
            { areaId: '420300', areaName: '十堰市' },
            { areaId: '420500', areaName: '宜昌市' },
            { areaId: '420600', areaName: '襄樊市' },
            { areaId: '420700', areaName: '鄂州市' },
            { areaId: '420800', areaName: '荆门市' },
            { areaId: '420900', areaName: '孝感市' },
            { areaId: '421000', areaName: '荆州市' },
            { areaId: '421100', areaName: '黄冈市' },
            { areaId: '421200', areaName: '咸宁市' },
            { areaId: '421300', areaName: '随州市' },
            { areaId: '422800', areaName: '恩施土家族苗族自治州' },
            { areaId: '429000', areaName: '省直辖县级行政单位' }
        ]
    },
    {
        areaId: '430000',
        areaName: '湖南省',
        disabled: false,
        child: [
            { areaId: '430100', areaName: '长沙市' },
            { areaId: '430200', areaName: '株洲市' },
            { areaId: '430300', areaName: '湘潭市' },
            { areaId: '430400', areaName: '衡阳市' },
            { areaId: '430500', areaName: '邵阳市' },
            { areaId: '430600', areaName: '岳阳市' },
            { areaId: '430700', areaName: '常德市' },
            { areaId: '430800', areaName: '张家界市' },
            { areaId: '430900', areaName: '益阳市' },
            { areaId: '431000', areaName: '郴州市' },
            { areaId: '431100', areaName: '永州市' },
            { areaId: '431200', areaName: '怀化市' },
            { areaId: '431300', areaName: '娄底市' },
            { areaId: '433100', areaName: '湘西土家族苗族自治州' }
        ]
    },
    {
        areaId: '440000',
        areaName: '广东省',
        disabled: false,
        child: [
            { areaId: '440100', areaName: '广州市' },
            { areaId: '440200', areaName: '韶关市' },
            { areaId: '440300', areaName: '深圳市' },
            { areaId: '440400', areaName: '珠海市' },
            { areaId: '440500', areaName: '汕头市' },
            { areaId: '440600', areaName: '佛山市' },
            { areaId: '440700', areaName: '江门市' },
            { areaId: '440800', areaName: '湛江市' },
            { areaId: '440900', areaName: '茂名市' },
            { areaId: '441200', areaName: '肇庆市' },
            { areaId: '441300', areaName: '惠州市' },
            { areaId: '441400', areaName: '梅州市' },
            { areaId: '441500', areaName: '汕尾市' },
            { areaId: '441600', areaName: '河源市' },
            { areaId: '441700', areaName: '阳江市' },
            { areaId: '441800', areaName: '清远市' },
            { areaId: '441900', areaName: '东莞市' },
            { areaId: '442000', areaName: '中山市' },
            { areaId: '445100', areaName: '潮州市' },
            { areaId: '445200', areaName: '揭阳市' },
            { areaId: '445300', areaName: '云浮市' }
        ]
    },
    {
        areaId: '450000',
        areaName: '广西壮族自治区',
        disabled: false,
        child: [
            { areaId: '450100', areaName: '南宁市' },
            { areaId: '450200', areaName: '柳州市' },
            { areaId: '450300', areaName: '桂林市' },
            { areaId: '450400', areaName: '梧州市' },
            { areaId: '450500', areaName: '北海市' },
            { areaId: '450600', areaName: '防城港市' },
            { areaId: '450700', areaName: '钦州市' },
            { areaId: '450800', areaName: '贵港市' },
            { areaId: '450900', areaName: '玉林市' },
            { areaId: '451000', areaName: '百色市' },
            { areaId: '451100', areaName: '贺州市' },
            { areaId: '451200', areaName: '河池市' },
            { areaId: '451300', areaName: '来宾市' },
            { areaId: '451400', areaName: '崇左市' }
        ]
    },
    {
        areaId: '460000',
        areaName: '海南省',
        disabled: false,
        child: [
            { areaId: '460100', areaName: '海口市' },
            { areaId: '460200', areaName: '三亚市' },
            { areaId: '469000', areaName: '省直辖县级行政单位' }
        ]
    },
    {
        areaId: '500000',
        areaName: '重庆市',
        disabled: false,
        child: [
            { areaId: '500101', areaName: '万州区' },
            { areaId: '500102', areaName: '涪陵区' },
            { areaId: '500103', areaName: '渝中区' },
            { areaId: '500104', areaName: '大渡口区' },
            { areaId: '500105', areaName: '江北区' },
            { areaId: '500106', areaName: '沙坪坝区' },
            { areaId: '500107', areaName: '九龙坡区' },
            { areaId: '500108', areaName: '南岸区' },
            { areaId: '500109', areaName: '北碚区' },
            { areaId: '500110', areaName: '綦江区' },
            { areaId: '500111', areaName: '大足区' },
            { areaId: '500112', areaName: '渝北区' },
            { areaId: '500113', areaName: '巴南区' },
            { areaId: '500114', areaName: '黔江区' },
            { areaId: '500115', areaName: '长寿区' },
            { areaId: '500116', areaName: '江津区' },
            { areaId: '500117', areaName: '合川区' },
            { areaId: '500118', areaName: '永川区' },
            { areaId: '500119', areaName: '南川区' },
            { areaId: '500120', areaName: '璧山区' },
            { areaId: '500151', areaName: '铜梁区' },
            { areaId: '500152', areaName: '潼南区' },
            { areaId: '500153', areaName: '荣昌区' },
            { areaId: '500154', areaName: '开州区' },
            { areaId: '500155', areaName: '梁平区' },
            { areaId: '500156', areaName: '武隆区' },
            { areaId: '500229', areaName: '城口县' },
            { areaId: '500230', areaName: '丰都县' },
            { areaId: '500231', areaName: '垫江县' },
            { areaId: '500233', areaName: '忠县' },
            { areaId: '500235', areaName: '云阳县' },
            { areaId: '500236', areaName: '奉节县' },
            { areaId: '500237', areaName: '巫山县' },
            { areaId: '500238', areaName: '巫溪县' },
            { areaId: '500240', areaName: '石柱土家族自治县' },
            { areaId: '500241', areaName: '秀山土家族苗族自治县' },
            { areaId: '500242', areaName: '酉阳土家族苗族自治县' },
            { areaId: '500243', areaName: '彭水苗族土家族自治县' }
        ]
    },
    {
        areaId: '510000',
        areaName: '四川省',
        disabled: false,
        child: [
            { areaId: '510100', areaName: '成都市' },
            { areaId: '510300', areaName: '自贡市' },
            { areaId: '510400', areaName: '攀枝花市' },
            { areaId: '510500', areaName: '泸州市' },
            { areaId: '510600', areaName: '德阳市' },
            { areaId: '510700', areaName: '绵阳市' },
            { areaId: '510800', areaName: '广元市' },
            { areaId: '510900', areaName: '遂宁市' },
            { areaId: '511000', areaName: '内江市' },
            { areaId: '511100', areaName: '乐山市' },
            { areaId: '511300', areaName: '南充市' },
            { areaId: '511400', areaName: '眉山市' },
            { areaId: '511500', areaName: '宜宾市' },
            { areaId: '511600', areaName: '广安市' },
            { areaId: '511700', areaName: '达州市' },
            { areaId: '511800', areaName: '雅安市' },
            { areaId: '511900', areaName: '巴中市' },
            { areaId: '512000', areaName: '资阳市' },
            { areaId: '513200', areaName: '阿坝藏族羌族自治州' },
            { areaId: '513300', areaName: '甘孜藏族自治州' },
            { areaId: '513400', areaName: '凉山彝族自治州' }
        ]
    },
    {
        areaId: '520000',
        areaName: '贵州省',
        disabled: false,
        child: [
            { areaId: '520100', areaName: '贵阳市' },
            { areaId: '520200', areaName: '六盘水市' },
            { areaId: '520300', areaName: '遵义市' },
            { areaId: '520400', areaName: '安顺市' },
            { areaId: '522200', areaName: '铜仁地区' },
            { areaId: '522300', areaName: '黔西南布依族苗族自治州' },
            { areaId: '522400', areaName: '毕节地区' },
            { areaId: '522600', areaName: '黔东南苗族侗族自治州' },
            { areaId: '522700', areaName: '黔南布依族苗族自治州' }
        ]
    },
    {
        areaId: '530000',
        areaName: '云南省',
        disabled: false,
        child: [
            { areaId: '530100', areaName: '昆明市' },
            { areaId: '530300', areaName: '曲靖市' },
            { areaId: '530400', areaName: '玉溪市' },
            { areaId: '530500', areaName: '保山市' },
            { areaId: '530600', areaName: '昭通市' },
            { areaId: '530700', areaName: '丽江市' },
            { areaId: '530800', areaName: '普洱市' },
            { areaId: '530900', areaName: '临沧市' },
            { areaId: '532300', areaName: '楚雄彝族自治州' },
            { areaId: '532500', areaName: '红河哈尼族彝族自治州' },
            { areaId: '532600', areaName: '文山壮族苗族自治州' },
            { areaId: '532800', areaName: '西双版纳傣族自治州' },
            { areaId: '532900', areaName: '大理白族自治州' },
            { areaId: '533100', areaName: '德宏傣族景颇族自治州' },
            { areaId: '533300', areaName: '怒江傈僳族自治州' },
            { areaId: '533400', areaName: '迪庆藏族自治州' }
        ]
    },
    {
        areaId: '540000',
        areaName: '西藏自治区',
        disabled: false,
        child: [
            { areaId: '540100', areaName: '拉萨市' },
            { areaId: '542100', areaName: '昌都地区' },
            { areaId: '542200', areaName: '山南地区' },
            { areaId: '542300', areaName: '日喀则地区' },
            { areaId: '542400', areaName: '那曲地区' },
            { areaId: '542500', areaName: '阿里地区' },
            { areaId: '542600', areaName: '林芝地区' }
        ]
    },
    {
        areaId: '610000',
        areaName: '陕西省',
        disabled: false,
        child: [
            { areaId: '610100', areaName: '西安市' },
            { areaId: '610200', areaName: '铜川市' },
            { areaId: '610300', areaName: '宝鸡市' },
            { areaId: '610400', areaName: '咸阳市' },
            { areaId: '610500', areaName: '渭南市' },
            { areaId: '610600', areaName: '延安市' },
            { areaId: '610700', areaName: '汉中市' },
            { areaId: '610800', areaName: '榆林市' },
            { areaId: '610900', areaName: '安康市' },
            { areaId: '611000', areaName: '商洛市' }
        ]
    },
    {
        areaId: '620000',
        areaName: '甘肃省',
        disabled: false,
        child: [
            { areaId: '620100', areaName: '兰州市' },
            { areaId: '620200', areaName: '嘉峪关市' },
            { areaId: '620300', areaName: '金昌市' },
            { areaId: '620400', areaName: '白银市' },
            { areaId: '620500', areaName: '天水市' },
            { areaId: '620600', areaName: '武威市' },
            { areaId: '620700', areaName: '张掖市' },
            { areaId: '620800', areaName: '平凉市' },
            { areaId: '620900', areaName: '酒泉市' },
            { areaId: '621000', areaName: '庆阳市' },
            { areaId: '621100', areaName: '定西市' },
            { areaId: '621200', areaName: '陇南市' },
            { areaId: '622900', areaName: '临夏回族自治州' },
            { areaId: '623000', areaName: '甘南藏族自治州' }
        ]
    },
    {
        areaId: '630000',
        areaName: '青海省',
        disabled: false,
        child: [
            { areaId: '630100', areaName: '西宁市' },
            { areaId: '632100', areaName: '海东地区' },
            { areaId: '632200', areaName: '海北藏族自治州' },
            { areaId: '632300', areaName: '黄南藏族自治州' },
            { areaId: '632500', areaName: '海南藏族自治州' },
            { areaId: '632600', areaName: '果洛藏族自治州' },
            { areaId: '632700', areaName: '玉树藏族自治州' },
            { areaId: '632800', areaName: '海西蒙古族藏族自治州' }
        ]
    },
    {
        areaId: '640000',
        areaName: '宁夏回族自治区',
        disabled: false,
        child: [
            { areaId: '640100', areaName: '银川市' },
            { areaId: '640200', areaName: '石嘴山市' },
            { areaId: '640300', areaName: '吴忠市' },
            { areaId: '640400', areaName: '固原市' },
            { areaId: '640500', areaName: '中卫市' }
        ]
    },
    {
        areaId: '650000',
        areaName: '新疆维吾尔自治区',
        disabled: false,
        child: [
            { areaId: '650100', areaName: '乌鲁木齐市' },
            { areaId: '650200', areaName: '克拉玛依市' },
            { areaId: '652100', areaName: '吐鲁番地区' },
            { areaId: '652200', areaName: '哈密地区' },
            { areaId: '652300', areaName: '昌吉回族自治州' },
            { areaId: '652700', areaName: '博尔塔拉蒙古自治州' },
            { areaId: '652800', areaName: '巴音郭楞蒙古自治州' },
            { areaId: '652900', areaName: '阿克苏地区' },
            { areaId: '653000', areaName: '克孜勒苏柯尔克孜自治州' },
            { areaId: '653100', areaName: '喀什地区' },
            { areaId: '653200', areaName: '和田地区' },
            { areaId: '654000', areaName: '伊犁哈萨克自治州' },
            { areaId: '654200', areaName: '塔城地区' },
            { areaId: '654300', areaName: '阿勒泰地区' },
            { areaId: '659000', areaName: '自治区直辖县级行政单位' }
        ]
    },
    {
        areaId: '810000',
        areaName: '中国香港',
        disabled: false,
        child: [{ areaId: '810001', areaName: '中国香港' }]
    },
    {
        areaId: '820000',
        areaName: '中国澳门',
        disabled: false,
        child: [{ areaId: '820001', areaName: '中国澳门' }]
    },
    {
        areaId: '830000',
        areaName: '海外',
        disabled: false,
        child: [{ areaId: '830001', areaName: '阿尔及利亚' },
            { areaId: '830002', areaName: '安哥拉' },
            { areaId: '830003', areaName: '贝宁' },
            { areaId: '830004', areaName: '博茨瓦纳' },
            { areaId: '830005', areaName: '英属印度洋领地' },
            { areaId: '830006', areaName: '布基纳法索' },
            { areaId: '830007', areaName: '布隆迪' },
            { areaId: '830008', areaName: '喀麦隆' },
            { areaId: '830009', areaName: '佛得角' },
            { areaId: '830010', areaName: '中非共和國' },
            { areaId: '830011', areaName: '乍得' },
            { areaId: '830012', areaName: '科摩罗' },
            { areaId: '830013', areaName: '刚果（金）' },
            { areaId: '830014', areaName: '刚果共和國' },
            { areaId: '830015', areaName: '科特迪瓦' },
            { areaId: '830016', areaName: '吉布提' },
            { areaId: '830017', areaName: '埃及' },
            { areaId: '830018', areaName: '赤道几内亚' },
            { areaId: '830019', areaName: '厄立特里亚' },
            { areaId: '830020', areaName: '埃塞俄比亚' },
            { areaId: '830021', areaName: '加蓬' },
            { areaId: '830022', areaName: '冈比亚' },
            { areaId: '830023', areaName: '加纳' },
            { areaId: '830024', areaName: '几内亚' },
            { areaId: '830025', areaName: '几内亚比绍' },
            { areaId: '830026', areaName: '肯尼亚' },
            { areaId: '830027', areaName: '莱索托' },
            { areaId: '830028', areaName: '利比里亚' },
            { areaId: '830029', areaName: '利比亚' },
            { areaId: '830030', areaName: '马达加斯加' },
            { areaId: '830031', areaName: '马拉维' },
            { areaId: '830032', areaName: '马里' },
            { areaId: '830033', areaName: '毛里塔尼亚' },
            { areaId: '830034', areaName: '毛里求斯' },
            { areaId: '830035', areaName: '摩洛哥' },
            { areaId: '830036', areaName: '莫桑比克' },
            { areaId: '830037', areaName: '纳米比亚' },
            { areaId: '830038', areaName: '尼日尔' },
            { areaId: '830039', areaName: '尼日利亚' },
            { areaId: '830040', areaName: '卢旺达' },
            { areaId: '830041', areaName: '圣多美和普林西比' },
            { areaId: '830042', areaName: '塞内加尔' },
            { areaId: '830043', areaName: '塞舌尔' },
            { areaId: '830044', areaName: '塞拉利昂' },
            { areaId: '830045', areaName: '索马里' },
            { areaId: '830046', areaName: '南非' },
            { areaId: '830047', areaName: '苏丹' },
            { areaId: '830048', areaName: '史瓦帝尼' },
            { areaId: '830049', areaName: '坦桑尼亚' },
            { areaId: '830050', areaName: '多哥' },
            { areaId: '830051', areaName: '突尼斯' },
            { areaId: '830052', areaName: '乌干达' },
            { areaId: '830053', areaName: '赞比亚' },
            { areaId: '830054', areaName: '津巴布韦' },
            { areaId: '830055', areaName: '南蘇丹' },
            { areaId: '830056', areaName: '阿富汗' },
            { areaId: '830057', areaName: '亚美尼亚' },
            { areaId: '830058', areaName: '阿塞拜疆' },
            { areaId: '830059', areaName: '巴林' },
            { areaId: '830060', areaName: '孟加拉国' },
            { areaId: '830061', areaName: '不丹' },
            { areaId: '830062', areaName: '文莱' },
            { areaId: '830063', areaName: '柬埔寨' },
            { areaId: '830064', areaName: '圣诞岛' },
            { areaId: '830065', areaName: '科科斯（基林）群岛' },
            { areaId: '830066', areaName: '塞浦路斯' },
            { areaId: '830067', areaName: '格鲁吉亚' },
            { areaId: '830068', areaName: '印度' },
            { areaId: '830069', areaName: '印尼' },
            { areaId: '830070', areaName: '伊朗' },
            { areaId: '830071', areaName: '伊拉克' },
            { areaId: '830072', areaName: '以色列' },
            { areaId: '830073', areaName: '日本' },
            { areaId: '830074', areaName: '约旦' },
            { areaId: '830075', areaName: '哈薩克斯坦' },
            { areaId: '830076', areaName: '朝鲜' },
            { areaId: '830077', areaName: '韩国' },
            { areaId: '830078', areaName: '科威特' },
            { areaId: '830079', areaName: '吉尔吉斯斯坦' },
            { areaId: '830080', areaName: '老挝' },
            { areaId: '830081', areaName: '黎巴嫩' },
            { areaId: '830082', areaName: '马来西亚' },
            { areaId: '830083', areaName: '马尔代夫' },
            { areaId: '830084', areaName: '蒙古' },
            { areaId: '830085', areaName: '缅甸' },
            { areaId: '830086', areaName: '尼泊尔' },
            { areaId: '830087', areaName: '阿曼' },
            { areaId: '830088', areaName: '巴基斯坦' },
            { areaId: '830089', areaName: '巴勒斯坦' },
            { areaId: '830090', areaName: '菲律宾' },
            { areaId: '830091', areaName: '卡塔尔' },
            { areaId: '830092', areaName: '俄罗斯' },
            { areaId: '830093', areaName: '沙特阿拉伯' },
            { areaId: '830094', areaName: '新加坡' },
            { areaId: '830095', areaName: '斯里兰卡' },
            { areaId: '830096', areaName: '叙利亚' },
            { areaId: '830097', areaName: '塔吉克斯坦' },
            { areaId: '830098', areaName: '泰国' },
            { areaId: '830099', areaName: '东帝汶' },
            { areaId: '830100', areaName: '土耳其' },
            { areaId: '830101', areaName: '土库曼斯坦' },
            { areaId: '830102', areaName: '阿联酋' },
            { areaId: '830103', areaName: '乌兹别克斯坦' },
            { areaId: '830104', areaName: '越南' },
            { areaId: '830105', areaName: '也门' },
            { areaId: '830106', areaName: '阿尔巴尼亚' },
            { areaId: '830107', areaName: '安道尔' },
            { areaId: '830108', areaName: '奥地利' },
            { areaId: '830109', areaName: '白俄罗斯' },
            { areaId: '830110', areaName: '比利时' },
            { areaId: '830111', areaName: '波黑' },
            { areaId: '830112', areaName: '保加利亚' },
            { areaId: '830113', areaName: '克罗地亚' },
            { areaId: '830114', areaName: '捷克' },
            { areaId: '830115', areaName: '丹麦' },
            { areaId: '830116', areaName: '爱沙尼亚' },
            { areaId: '830117', areaName: '芬兰' },
            { areaId: '830118', areaName: '法国' },
            { areaId: '830119', areaName: '德国' },
            { areaId: '830120', areaName: '希腊' },
            { areaId: '830121', areaName: '匈牙利' },
            { areaId: '830122', areaName: '冰岛' },
            { areaId: '830123', areaName: '爱尔兰' },
            { areaId: '830124', areaName: '意大利' },
            { areaId: '830125', areaName: '拉脱维亚' },
            { areaId: '830126', areaName: '列支敦士登' },
            { areaId: '830127', areaName: '立陶宛' },
            { areaId: '830128', areaName: '卢森堡' },
            { areaId: '830129', areaName: '马其顿' },
            { areaId: '830130', areaName: '马耳他' },
            { areaId: '830131', areaName: '摩尔多瓦' },
            { areaId: '830132', areaName: '摩纳哥' },
            { areaId: '830133', areaName: '黑山' },
            { areaId: '830134', areaName: '荷兰' },
            { areaId: '830135', areaName: '挪威' },
            { areaId: '830136', areaName: '波兰' },
            { areaId: '830137', areaName: '葡萄牙' },
            { areaId: '830138', areaName: '罗马尼亚' },
            { areaId: '830139', areaName: '俄罗斯' },
            { areaId: '830140', areaName: '圣马力诺' },
            { areaId: '830141', areaName: '塞尔维亚' },
            { areaId: '830142', areaName: '斯洛伐克' },
            { areaId: '830143', areaName: '斯洛文尼亚' },
            { areaId: '830144', areaName: '西班牙' },
            { areaId: '830145', areaName: '斯瓦巴' },
            { areaId: '830146', areaName: '瑞典' },
            { areaId: '830147', areaName: '瑞士' },
            { areaId: '830148', areaName: '乌克兰' },
            { areaId: '830149', areaName: '英国' },
            { areaId: '830150', areaName: '梵蒂冈' },
            { areaId: '830151', areaName: '安提瓜和巴布达' },
            { areaId: '830152', areaName: '巴哈马' },
            { areaId: '830153', areaName: '巴巴多斯' },
            { areaId: '830154', areaName: '伯利兹' },
            { areaId: '830155', areaName: '加拿大' },
            { areaId: '830156', areaName: '哥斯达黎加' },
            { areaId: '830157', areaName: '古巴' },
            { areaId: '830158', areaName: '多米尼克' },
            { areaId: '830159', areaName: '多米尼加' },
            { areaId: '830160', areaName: '萨尔瓦多' },
            { areaId: '830161', areaName: '格林纳达' },
            { areaId: '830162', areaName: '危地马拉' },
            { areaId: '830163', areaName: '海地' },
            { areaId: '830164', areaName: '洪都拉斯' },
            { areaId: '830165', areaName: '牙买加' },
            { areaId: '830166', areaName: '墨西哥' },
            { areaId: '830167', areaName: '尼加拉瓜' },
            { areaId: '830168', areaName: '巴拿马' },
            { areaId: '830169', areaName: '圣基茨和尼维斯' },
            { areaId: '830170', areaName: '圣卢西亚' },
            { areaId: '830171', areaName: '圣文森特和格林纳丁斯' },
            { areaId: '830172', areaName: '特立尼达和多巴哥' },
            { areaId: '830173', areaName: '美国' },
            { areaId: '830174', areaName: '阿根廷' },
            { areaId: '830175', areaName: '玻利维亚' },
            { areaId: '830176', areaName: '巴西' },
            { areaId: '830177', areaName: '智利' },
            { areaId: '830178', areaName: '哥伦比亚' },
            { areaId: '830179', areaName: '厄瓜多尔' },
            { areaId: '830180', areaName: '福克兰群岛' },
            { areaId: '830181', areaName: '法属圭亚那' },
            { areaId: '830182', areaName: '圭亚那' },
            { areaId: '830183', areaName: '巴拉圭' },
            { areaId: '830184', areaName: '秘鲁' },
            { areaId: '830185', areaName: '苏里南' },
            { areaId: '830186', areaName: '乌拉圭' },
            { areaId: '830187', areaName: '委内瑞拉' },
            { areaId: '830188', areaName: '澳大利亚' },
            { areaId: '830189', areaName: '库克群岛' },
            { areaId: '830190', areaName: '斐济' },
            { areaId: '830191', areaName: '基里巴斯' },
            { areaId: '830192', areaName: '马绍尔群岛' },
            { areaId: '830193', areaName: '密克罗尼西亚' },
            { areaId: '830194', areaName: '瑙鲁' },
            { areaId: '830195', areaName: '新西兰' },
            { areaId: '830196', areaName: '纽埃' },
            { areaId: '830197', areaName: '帕劳' },
            { areaId: '830198', areaName: '巴布亚新几内亚' },
            { areaId: '830199', areaName: '萨摩亚' },
            { areaId: '830200', areaName: '所罗门群岛' },
            { areaId: '830201', areaName: '汤加' },
            { areaId: '830202', areaName: '图瓦卢' },
            { areaId: '830203', areaName: '瓦努阿图' }
        ]
    }
] // 后端返回的地区列表
